/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `Es wurde keine Route gefunden. Können Sie Ihre Suche bitte ändern?`
};

const en_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `We haven't found any itineraries. Can you modify your search?`
};

const es_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `No hemos encontrado ningun itinerario. ¿Puedes modificar tu búsqueda?`
};

const fr_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `Nous n’avons trouvé aucun itinéraire. Pouvez-vous modifier votre recherche ?`
};

const it_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `Non abbiamo trovato nessun itinerario. Puoi modificare la ricerca?`
};

const nl_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `We hebben geen route gevonden. Kunt u uw zoekopdracht aanpassen?`
};

const pt_route__not_found = /** @type {(inputs: {}) => string} */ () => {
	return `Não encontrámos nenhum itinerário. Pode modificar a sua pesquisa?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__not_found = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__not_found(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__not_found", locale)
	if (locale === "de") return de_route__not_found(inputs)
	if (locale === "en") return en_route__not_found(inputs)
	if (locale === "es") return es_route__not_found(inputs)
	if (locale === "fr") return fr_route__not_found(inputs)
	if (locale === "it") return it_route__not_found(inputs)
	if (locale === "nl") return nl_route__not_found(inputs)
	return pt_route__not_found(inputs)
};